// extracted by mini-css-extract-plugin
export default {"bord":"board_bord__RyxbD","board_row":"board_board_row__KNuIO","restartBtn":"board_restartBtn__iWiwF","status":"board_status__o85c4"};